import { QueryObserverResult, useQuery } from 'react-query';
import { User } from '../../../../types';
import { parseUser } from '../../../../utils/parseUser';
import AuthCheckRequest from '../../../requests/Auth/AuthCheckRequest';

export default function useAuthenticationCheck(
	enabled = false,
): QueryObserverResult<User> {
	return useQuery(
		'user',
		async () => {
			const { data } = await AuthCheckRequest();
			const parsedUser = parseUser(data);
			return parsedUser;
		},
		{
			staleTime: 180000,
			retry: false,
			enabled,
		},
	);
}
